import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormFields } from '~/components/FormFields';
import { Grid } from 'semantic-ui-react';
import EmailForm from './EmailForm';
import { useAuth } from '~/routes/components/AuthProvider';
import { FAT_PROTEIN_SLUG, MILK_FIXED_SLUG, MILK_MONEY_ACCOUNT_SLUG, MILK_STOCK_EXCHANGE } from '~/Constants';

const tradingSlotSlugs = [MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE, FAT_PROTEIN_SLUG]

const Notifications: React.FC = () => {
  const { systemData: { modules } } = useAuth()
  const { control } = useFormContext();
  const { t } = useTranslation();

  const hasAnyTradingSlot = Boolean(modules.find(module => !!tradingSlotSlugs.find(tradingSlotSlug => tradingSlotSlug === module.slug)))
  const hasMilkMoney = modules.find(module => module.slug === MILK_MONEY_ACCOUNT_SLUG)

  const emails = []

  if (hasAnyTradingSlot) {
    emails.unshift({
      title: t('New trading slot emails'),
      emailKey: 'newTradingSlotEmails',
      requiredKey: 'newTradingSlotEmailStatus'
    },
    {
      title: t('Summary emails'),
      emailKey: 'summaryEmails',
      requiredKey: 'summaryEmailStatus'
    },
    {
      title: t('Trading slot completion emails'),
      emailKey: 'completedSummaryEmails',
      requiredKey: 'completedSummaryStatus'
    })
  }

  if (hasMilkMoney) {
    emails.push({
      title: t('Tour import emails'),
      emailKey: 'toursImportErrorEmails',
      requiredKey: 'toursImportErrorStatus'
    })
  }

  return (
    <>
      <Grid columns={2} stackable style={{ marginBottom: '2rem' }}>
        <Grid.Column>
          {hasAnyTradingSlot && <>
            <FormFields.Checkbox
              control={control}
              checkboxValue={1}
              defaultValue={0}
              name='newTradingSlotEmailStatus'
              label={t('Send new trading slot email?')}
            />
            <FormFields.Checkbox
              control={control}
              checkboxValue={1}
              defaultValue={0}
              name='summaryEmailStatus'
              label={t('Send summary?')}
            />
            <FormFields.Checkbox
              control={control}
              checkboxValue={1}
              defaultValue={0}
              name='completedSummaryStatus'
              label={t('Send trading slot completion?')}
            />
          </>}
          <FormFields.Checkbox
            control={control}
            checkboxValue={1}
            defaultValue={0}
            name='toursImportErrorStatus'
            label={t('Send tours import errors?')}
          />
        </Grid.Column>
        <Grid.Column>
          {emails.map(email => {
            return <EmailForm
              key={email.requiredKey}
              {...email}
            />
          })}
        </Grid.Column>
      </Grid>
    </>
  );
};

export default Notifications;
